import Home from './index.vue'

export default [
  { path: '/biz/log', component: Home, meta: { auth: true } }
]